define(function (require) {
	const DetailPageModel = require('civicsModels/core/detail_page_model');
	const DetailObjectModel = require('civicsModels/core/detail_object_model');
	const ViewManager = require('civicsUtils/view_manager');
	const ViewBindingManager = require('civicsUtils/view_binding_manager');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');

	const ModalDetailView = require('./modal_view/v_lov_modal_detail');
	const ModalRegion = require('civicsUtils/modal_region');
	const ModalConfirmation = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
	const IpsModel = require('civicsBase/ipsModel');
	require('civicsUtils/civicsDroppy');
	return Marionette.LayoutView.extend({
		modelEvents: {
			change: 'render'
		},
		events: {
			'click @ui.btnSaveDetail': 'saveDetailClicked',
			'click @ui.btnEdit': 'editClicked',
			'click @ui.btnCancelDetail': 'cancelClicked',
			'click @ui.btnCollapse': 'clickCollapse'
		},
		ui: {
			btnSaveDetail: '.btn-save-detail',
			btnRowDelete: '.btn-row-delete',
			btnEdit: '.edit-btn',
			btnCancelDetail: '.btn-cancel-detail',
			paddedContent: '.padded-content',
			dates: '[data-formatType=date]',
			btnCollapse: '.btn-collapse',
			collapsible: '.collapsible-wrapper',
			modalRegionDiv: '.modal-detail-region',
			detailPageContent:'.detail-page-content'
		},
		regions: {
			detailPageContentRegion: '@ui.detailPageContent',
			modalRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			}
		},
		initialize: function (options) {
			this.useNewDetails = true;
			this.config = options.config;
			//isAdd is ALWAYS TRUE if we are in add instrument. if we are in Instrument Details, it is always false.
			//we can use this to determine whether to allow edit/delete/add permissions in conjunction with the appropriate
			//table attributes from IPS
			this.isAdd = options.isAdd;
			this.enabled = options.initialEnabled == undefined ? true : options.initialEnabled;
			this.toggleEnabled = options.toggleEnabled == undefined ? false : options.toggleEnabled;
			this.ineffectiveApplicant = options.ineffectiveApplicant == undefined ? false: options.ineffectiveApplicant;
			this.useDetailCollection = options.useDetailCollection;
			this.aggregateModel = options.aggregateModel;
			this.aggregateModelDetailPropertyId = options.aggregateModelDetailPropertyId;
			this.loadParentHansenModel = options.loadParentHansenModel;
			this.defaultExpanded = options.defaultExpanded;
			this.modelsToDelete = [];

			this.expandState = this.isExpanded();		//Is this currently expanded or collapsed?

			var classNameBind = 'className';
			var className = this.model.get(classNameBind);

			//this promise will manage the timing of displaying the detail page. when this promise is resolved, the contents will be rendered.
			this.renderDetailPageContent = $.Deferred();

			var self = this;
			if (className && className.length > 0) {
				this.mDetailPage = new DetailPageModel();
				this.mDetailPage.className = className;
				this.mDetailPage.fetch({
					error: (model, response, options) => {
						ViewManager.errorToWindow(response, this);
					}
				}).done(function (response, status, xhrResponse) {
					var childProperty;
					var childMoniker;
					//if we're able to edit, we should check that there's anything to edit.
					self.hasFields = true;
					if(self.mDetailPage){
						var dp = self.mDetailPage.toJSON();
						if(dp.document && !self.checkForFields(dp.document.elements)){
							//if there are no editable fields on the detail page, don't allow editing.
							self.hasFields = false;
						}

						var childProperty = self.mDetailPage.get('detailPage.childProperty');
						var childMoniker = self.mDetailPage.get('detailPage.childMoniker');
					}


					if (childProperty && childMoniker && childProperty.trim() != '' && childMoniker.trim() != '') {

						var moniker = childMoniker;
						self.isGrid = moniker.endsWith('Collection');
						if (self.isGrid) {
							//This is the bind that the detail page service rturns even though there really is no bind for a grid as detail page
							self.gridBind = moniker.substring(moniker.lastIndexOf('.') + 1, moniker.length)

							// trim the trailing collection for the generic service
							moniker = moniker.substring(0, moniker.lastIndexOf('Collection'));
						}

						var resetKeys = false;
						var dataLoadPromise = $.Deferred();
						//todo: check if we can popuplate the data first
						if (self.isAdd && (self.config == null || self.config.useGenericService!==true)) {
							var details;
							var detail;

							if ( self.loadParentHansenModel ){
								self.loadParentHansenModel.dynamicBinds = self.getBinds();
								self.loadParentHansenModel.dynamicMoniker = moniker;
								self.loadParentHansenModel.dynamicPropertyId = self.aggregateModelDetailPropertyId;
								dataLoadPromise = self.loadParentHansenModel.fetch().done(() => {
										var loadedDetails = self._findParentObject(self.aggregateModel, self.aggregateModelDetailPropertyId);
										var loadedDetail = self._findCurrentObject(loadedDetails, self.useDetailCollection);
										//loadedDetail.set('id',0,{silent:true});
										loadedDetail.unset('id',{silent:true});
										delete loadedDetail.id;
										// now finding all bindings that is a key values
										// then remove the key value for cloning
										details = self._findParentObject(self.loadParentHansenModel, self.aggregateModelDetailPropertyId);
										detail = self._findCurrentObject(details, self.useDetailCollection);
										// now that we have setup a new loaded detail , set it back to the aggregateRoot
										self.aggregateModel.set(self.detailsPropertyId,details,{silient:true});
										// resetKeys = true;
									})
									.fail(function(response, status, xhrResponse) {
										ViewManager.errorToWindow(response);
									})
							}
							else {
								dataLoadPromise.resolve();
							}


							$.when(dataLoadPromise).done(_.bind(function() {
								// convert a detail property into a generic service model like how we treat the viewer below
								if (!details) details = self._findParentObject(self.aggregateModel, self.aggregateModelDetailPropertyId);
								if (!detail) detail = self._findCurrentObject(details, self.useDetailCollection);
								var actualData;
								// if not using detail collection, the data can just be plugged right in
								if ( self.useDetailCollection ){
									var keys = _.keys(detail.attributes);
									//the data is stored in an attribute like $InforClient.Liferay7Test.liferay7Test or something similar. if we don't find that, we don't have data we need to display.
									if (keys && keys.length > 0) {
										var agencyKey = _.find(keys, k => {
											return k.startsWith('$')
										});
										if (agencyKey) {
											actualData = detail.attributes[agencyKey];
										}
									}
								} else {
									actualData = detail;
								}
								if (actualData != undefined) {
									self.m = new IpsModelCollection();

									self.m.add(actualData.toJSON());
									//}
									// if (resetKeys) {
									// 	if (actualData.resetKeyValues) {
									// 		var keyBinds = self.getKeyBinds();
									// 		actualData.resetKeyValues(keyBinds);
									// 	}
									// }
									self.agencyDataReady = true;
								}

								self.render();
								self.renderDetailPageContent.resolve();
							}));
						}
						else {
							//self.aggregateRoot -> details array has detail data
							//self.mDetailPAge.detailPage.childMoniker has detail name
							var detailName = self.mDetailPage.get('detailPage.childMoniker');
							var detailData = self.getDetailData(self.aggregateModel, detailName);
							if (detailData !== false) {
								self.m = new IpsModelCollection();
								self.m.add(detailData.toJSON());
								self.agencyDataReady = true;
								if (!self.isDestroyed) {
									self.render();
									self.renderDetailPageContent.resolve();
								}
							} else {
								var selects = self.mDetailPage.get('detailPage.childPrimaryKey');
								if (self.isGrid) {
									// if this is grid, the bind already include the primary key , so we dont have to default it
									selects = '';
								}
								// now retrieve all the binds from content
								var binds = self.getBinds();

								if (binds && binds.length > 0) {
									var filter = '{property:' + childProperty + ',value:' + self.model.parentId + '}';
									_.forEach(binds, b => {
										selects = selects + ',' + b;
									});
									// save the selects for updates
									self.selects = selects;
									var root = '/delegate/civics-api/api/generic/{0}?filter={1}&select=[{2}]'.format(moniker, filter, selects);
									var GenCollection = IpsModelCollection.extend({
										urlRoot: root,
									});

									self.m = new GenCollection();
									self.m.fetch({
										error: function (model, response, options) {
											ViewManager.errorToWindow(response, this);
										}
									}).done((response, status, xhrResponse) => {
										self.agencyDataReady = true;
										if (self.isAdd) {
											//need to unset the detail ID, otherwise it messes up the record we clone from
											var loadedDetails = self._findParentObject(self.aggregateModel, self.aggregateModelDetailPropertyId);
											var loadedDetail = self._findCurrentObject(loadedDetails, self.useDetailCollection);
											//loadedDetail is a reference to self.aggregateModel. when we delete it here, it's deleted off aggregatModel
											loadedDetail.unset('id', { silent: true });
											delete loadedDetail.id;

											
										}
										if (!self.isDestroyed) {
											self.render();
											self.renderDetailPageContent.resolve();
										}
										//ViewManager.loading(false,self);
									});
								} else {
									//no binds present, but we still need to render the detail page.
									self.render();
									self.renderDetailPageContent.resolve();
								}
							}
						}
					}
				}).fail(function (response, status, xhrResponse) {
					//ViewManager.loading(false,this);
					ViewManager.errorToWindow(response);
				});
			}
			else {
				//ViewManager.loading(false,this);
			}
		},
		getDetailData: function (mdl, detailName) {
			var ret = false;
			if (mdl && mdl instanceof Backbone.Model) {
				var details = mdl.get(this.aggregateModelDetailPropertyId);
				if (details && details.length > 0) {
					//cant access a parameters with $ in it via model.get
					var detname = '$' + detailName;
					if (this.isGrid && detname.length > 10 && detname.substr(detname.length - 10) == 'Collection') {
						//remove the Collection from the end
						detname = detname.substr(0, detname.length - 10);
					}
					details.forEach((det) => {
						var detData = det.attributes[detname];
						if (detData) {
							ret = detData;
						}
					});
				}
			}
			return ret;
		},
		//this checks the document for
		checkForFields:function(elements){

			var fieldsExist = false;
			$.each(elements,function(index,el){									
				if(el.elements && !fieldsExist){
					fieldsExist = this.checkForFields(el.elements);
				} else {
					var tp = el.type ? el.type.toLowerCase() : '';
					if(tp!='label' && tp!='panel'){
						fieldsExist = true;
					}
				}
				
				//If there are fields, break out of each.
				if( fieldsExist )
					return false;
			}.bind(this));
			return fieldsExist;
		},
		getKeyBinds: function(){
			var content = this.mDetailPage.get('document');
			if (content && content.get) {
				content = content.toJSON();
			}
			return ViewBindingManager.getKeyBindsFromDocument(content, this.isGrid);
		},
		getBinds: function(){
			var content = this.mDetailPage.get('document');
			if (content && content.get) {
				content = content.toJSON();
			}
			return ViewBindingManager.getBindsFromDocument(content, this.isGrid);
		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

		},
		onShow: function () {
			$.when(this.renderDetailPageContent).done(function () {
				this.showDetailPageContent();
			}.bind(this))
		},
		showDetailPageContent: function () {
			if (this.detailView) {
				this.detailView.destroy();
				this.detailPageContentRegion.empty();
			}
			this.render();
			var elements;
			if (this.mDetailPage) {
				elements = this.mDetailPage.get('document');
				if (elements && elements.get) {
					elements = elements.toJSON();
					//if elements is an array, we're good. Otherwise, grab elements.elements, which should be an array
					//the actual elements list is wrapped in an otherwise empty object.
					if (!Array.isArray(elements)) {
						elements = elements.elements;
					}
				}
				if (this.isGrid &&
					this.agencyDataReady &&
					this.m &&
					this.m.models &&
					this.m.models.length > 0 &&
					this.m.models[0].get(this.gridBind) == undefined) {
					//we need to get the data from the RS into the same format as the data for normal detail pages. however if we already have an attribute with the gridbind name, we can skip this step.
					var m = new IpsModelCollection();
					var mod = new IpsModel();
					mod.set(this.gridBind, this.m.toJSON());
					m.push(mod);
					this.m = m;
				}
				this.detailView = new ModalDetailView({
					config: this.config,
					isModal: false,
					elements: elements,
					moniker: this.mDetailPage.get('detailPage.childMoniker'),
					values: this.m && this.m.models && this.m.models.length > 0 ? this.m.models[0] : null,
					readOnlyForm: this.enabled == false
				});
				this.detailPageContentRegion.show(this.detailView);
			}
		},
		onDomRefresh:function(){
			//this jquery selector checks for attributes added by the maxlength function.
			//if it finds them, it filters out that text area as it already has the character count applied.
			this.$el.find('textarea:not([aria-labelledby|="character-count-label"])').each(function(index, ta){
				$(ta).maxlength();
			});
		},
		isExpanded: function(){
			if( this.isAdd ){
				this.expandState = this.defaultExpanded;
				return this.defaultExpanded;		//always initially show as expanded in add mode
			}

			if( this.enabled){
				this.expandState = true;
				return true;		//always initially show as expanded in add mode

			}

			return this.expandState ? this.expandState : false;
		},
		validate: function () {
			// extract validation rules from the controls
			var content = this.mDetailPage.get('document');
			if (content && content.get) {
				content = content.toJSON();
			}
			var validation = ViewBindingManager.getValidationFromDocument(content);
			var IpsModelValid = IpsModel.extend({
				validation: validation
			});
			var model = new IpsModelValid(this.getData());
			return model.validate();
		},
		_getChildMoniker: function(ignoreDynamicSymbol){
			var childMoniker = this.mDetailPage != null ? this.mDetailPage.get('detailPage.childMoniker'): "";
			if (this.isGrid && childMoniker.endsWith('Collection')) {
				childMoniker = childMoniker.substr(0, childMoniker.length - 10); // no need to check for the words collection again for performance
			}
			if ( ignoreDynamicSymbol ){
					return childMoniker;
			}
			return '${0}'.format(childMoniker);
		},
		_findParentObject: function (model, detailsPropertyId) {
			var aggregateRoot = model;
			if (!_.isEmpty(detailsPropertyId)) {
				aggregateRoot = model.get(detailsPropertyId);
				if (!aggregateRoot) {
					// make sure the details collection exists
					aggregateRoot = new IpsModelCollection();
					//set it back to the main model
					model.set(detailsPropertyId, aggregateRoot, {silent: true});
				}
			}
			return aggregateRoot;
		},
		_findCurrentObject: function (aggregateRoot, useDetailCollection) {
			var detail;
			if (useDetailCollection) {
				var currTypeId = this.model.id;
				var detail = _.find(aggregateRoot.models, d => {
					return d.get('detailType.id') == currTypeId;
				});
				//if you cant find them by ID, look by class name.
				if(!detail){
					var className = this.model.get('className');
					if(className){
						for (var i=0; i<aggregateRoot.models.length; i++){
							var keys = Object.keys(aggregateRoot.models[i].attributes);
							for(var j = 0; j< keys.length; j++){
								if(keys[j].indexOf(className) > 0 && key[j].startsWith('$')){
									detail = aggregateRoot.models[i];
									break;
								}
							}
							if(detail){
								break;
							}
						}
					}
				}

				// now make sure the detail exists, if not, set it to the model itself
				if (!detail) {
					var newDetail = new IpsModel();
					newDetail.set({'detailType': this.model.toJSON()}, {silent: true});
					aggregateRoot.add(newDetail, {silent: true});
					detail = newDetail;
				}
				return detail;
			}
			else {
				var childMoniker = this._getChildMoniker();
				detail = aggregateRoot.attributes[childMoniker];
				if (!detail) {
					newDetail = new IpsModel();
					//without this, we lose the ability to save data between steps in addinstrument.
					newDetail.set({'detailType': this.model.toJSON()}, {silent: true});
					aggregateRoot.set(childMoniker, newDetail, {silent: true});
					detail = newDetail;
				}
			}

			return detail;
		},
		onSaveData: function (model, detailsPropertyId, useDetailCollection, skipValidation) {
			//if ( this._isValid && this.validate()  ){

			// saveData save serialize each detail view and put the data in the 'details' property
			var data = this.getData(skipValidation);
			var details = this._findParentObject(model, detailsPropertyId);
			var detail = this._findCurrentObject(details, useDetailCollection);

			var agencyData = {};
			if ( useDetailCollection ){
				agencyData[this._getChildMoniker()] = data;
			}
			else{
				agencyData = data;
			}
			detail.set(agencyData, {silent: true});
			//}
		},

		areYouSure:function(e){
			if(this.enabled){
				var ret = i18n.t('CIVICS.INSTRUMENT_SUBMIT.UNSAVED_CHANGES');
				(e || window.event).returnValue = ret;
				return ret;
			}
			return undefined;

		},
		cancelClicked: function (e) {
			if (this.originalData) {
				this.m = new IpsModelCollection();
				this.m.push(this.originalData);
			}
			this.editClicked(e);
		},
		editClicked: function (e) {
			this.enabled = !this.enabled;
			if(!this.enabled){
				//unbind the unsaved changes alert
				window.removeEventListener("beforeunload", this.areYouSure.bind(this));
				this.modelsToDelete = [];//clear array of models to delete
			} else {
				//we're starting to edit. save the original values off.
				if (this.m) {
					this.originalData = this.m.toJSON();
				}
			}

			if(this.m && this.m.length > 0){
				this.agencyDataReady = true;
			}
			this.showDetailPageContent();
			this.ui.paddedContent.fadeOut("fast");
			this.ui.paddedContent.fadeIn("slow");
			this.ui.collapsible.addClass("expanded");
			this.expandState = true;
		},
		clickCollapse: function(e){
			this.expandState = !this.expandState;
		},
		getData: function (skipValidation) {
			var data;
			if (this.detailView) {
				data = this.detailView.getData(skipValidation);
				if (this.isGrid && !$.isEmptyObject(data)) {
					//this flag is used in the application_start_validation_model and the instrumnet_model when post/put-ing to the server.
					data.thisIsAGridSoRemoveTheBind = true
				}
			}
			return data;
		},
		modalRowAdded: function(e){
			var $btn = $(e.target);

			//pass the table in to the modal view to ensure the correct table is updated.
			//previously, using the name would result in multiple issues if a read only and edit version of the grid were present,
			//like in add Instrument if you go to the submit page and hit back then alter the table.
			var $table = $btn.parents('.grid-wrapper').find('table');

			//the detail page ID is used to locate stored drop down options
			var detailPageId = $btn.parents('[data-detailpageid]').data('detailpageid');

			//we stored the grid fields here. using .data means we get an object back.
			var elements = $table.data('gridelements');

			//grab the grid name, so we can target the grid later when adding the row to it
			var gridName = $table.attr('name');

			//grab the moniker for autocomplete purposes
			var moniker = $table.data('moniker');

			if(this.modalRowView!=null){
				this.modalRegion.empty();
			}
			var config = $.extend({},this.config,
				{
					gridName:gridName,
					gridMoniker:moniker,
					isModal:true,
					detailPageId:detailPageId
				});
			this.modalRowView = new ModalDetailView({
				config:config,
				elements:elements,
				moniker:moniker,
				table:$table,
				newRow:true

			});
			this.modalRegion.show(this.modalRowView);
			this.modalRegion.showModal();
		},
		modalEditRow:function(e){
			var $btn = $(e.target);

			//pass the table in to the modal view to ensure the correct table is updated.
			//previously, using the name would result in multiple issues if a read only and edit version of the grid were present,
			//like in add Instrument if you go to the submit page and hit back then alter the table.
			var $table = $btn.parents('.grid-wrapper').find('table');

			//the detail page ID is used to locate stored drop down options
			var detailPageId = $btn.parents('[data-detailpageid]').data('detailpageid');

			//the add row button has all the necessary data on it.
			var $addRowButton = $btn.closest('.grid-wrapper').find('.btn-modal-row-add');

			//we stored the grid fields here. using .data means we get an object back.
			var elements = $table.data('gridelements');

			//grab the grid name, so we can target the grid later when adding the row to it
			var gridName = $table.attr('name');

			//grab the moniker for autocomplete purposes
			var moniker = $table.data('moniker');

			//when adding a row to the table, either from the server or from manual entry, we add the value data to the keyvalue column.
			//this is used when saving the data, or when editing the row as we're doing here.
			var values = $btn.parent().siblings('[data-iskeyvalue="true"]').data('rowvalues');

			//grab the row ID so we can put the updated data into the same row, rather than removing the entire row and adding a new one.
			//this way the edited row stays in the same spot as it was before the edit.
			var rowID = $btn.closest('tr').attr('data-rowid');

			var newRow = $btn.closest('tr').attr('data-newRow');

			if(this.modalRowView!=null){
				this.modalRegion.empty();
			}
			var config = $.extend({},this.config,
				{
					gridName:gridName,
					gridMoniker:moniker,
					isModal:true,
					detailPageId:detailPageId
				});
			this.modalRowView = new ModalDetailView({
				config:config,
				elements:elements,
				values:values,
				rowID:rowID,
				moniker:moniker,
				editingRow:true,
				table:$table,
				newRow:newRow

			});
			this.modalRegion.show(this.modalRowView);
			this.modalRegion.showModal();

		},
		processGridItemToDelete: function(table){
			var self = this;

			// setup the model up front and fire the request when the save
			var dataRemove = table.data('dataRemove');
			if (dataRemove && _.isArray(dataRemove) && dataRemove.length > 0) {
				_.forEach(dataRemove, d => {
					var m = new DetailObjectModel();
					var firstProp = 'id';

					var genModelProps = {};
					var firstPropSet = false;
					for (var propertyName in d) {
						if (!_.isObject(d[propertyName])) {
							if (!firstPropSet) {
								// setting the first property name just to tell the model this generic model is not new
								firstProp = propertyName;
							}
							genModelProps[propertyName] = d[propertyName];
						}
					}
					if ( ViewManager.versionRange('8.7.0.1912', '8.8') || ViewManager.versionRange('8.8.0.2001') ) {
						genModelProps['aggregateroot'] = self.mDetailPage.get('detailPage.childMoniker');
						genModelProps['aggregaterootbind'] = $(table).attr('name') || $(table).data('name');
					}
					m = _.extend(m, {'idAttribute': firstProp});
					if ( self.isGrid ){
						m.moniker = self._getChildMoniker(true);
					}
					else{
						m.moniker = $(table).attr('moniker') || $(table).data('moniker');
					}
					m.sendAsQueryString = true;
					m.set(genModelProps);
					this.modelsToDelete.push(m);
					table.data('dataRemove', []);
				});
			}
		},
		rowDeletedConfirmed: function (e) {

			var table = $(e.currentTarget).closest('table');
			$(table).removeGridRow($(e.currentTarget).closest('tr'));

			this.processGridItemToDelete(table);
		},
		rowDeleted:function(e){
			var self= this;
			var confModal = new ModalConfirmation({
				title:i18n.t('CIVICS.INSTRUMENT_SUBMIT.DELETE_ROW_CONFIRMATION_TITLE'),
				instructions:i18n.t('CIVICS.INSTRUMENT_SUBMIT.DELETE_ROW_CONFIRMATION_TEXT'),
				submitButtonText:i18n.t('CIVICS.COMMON.DELETE'),
				confirmationCallback:function(){
					self.rowDeletedConfirmed(e);
					self.modalRegion.empty();
				}
			});
			this.modalRegion.empty();
			this.modalRegion.show(confModal);
			this.modalRegion.showModal();

		},
		templateHelpers: function () {
			var content = '';
			if (this.mDetailPage) {
				content = this.mDetailPage.get('document');
				if (content && content.get) {
					content = content.toJSON();
				}
			}
			return {
				doc: content,
				enabled: this.enabled,
				hasFields: this.hasFields === false ? false : true,
				toggleEnabled: this.toggleEnabled
			};
		}
	});
});
